
(function () {
  function openWhatsApp() {
    // ✅ Anchor click method — most reliable, never blocked by browser
    var a = document.createElement('a');
    a.href = 'https://api.whatsapp.com/send?phone=919204500891&text=Hi';
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function attachHandlers() {

    // ── BOX 1: Size Chart ──
    // data-fayon-bound prevents duplicate listeners if script loads twice
    var sizeLabel = document.getElementById('fayon-id-standard-size');
    if (sizeLabel && !sizeLabel.getAttribute('data-fayon-bound')) {
      sizeLabel.setAttribute('data-fayon-bound', '1');
      sizeLabel.addEventListener('click', function (e) {
        var kiwiBtn = document.querySelector('.ks-chart-modal-link');
        if (kiwiBtn) {
          // ✅ Size chart exists — open it
          e.preventDefault();
          kiwiBtn.click();
        }
        // ✅ Size chart NOT found — do nothing, no crash, no error
      }, true); // capture phase
    }

    // ── BOX 3: WhatsApp ──
    // data-fayon-wa-bound prevents duplicate listeners
    var waLabel = document.getElementById('fayon-id-call-for-assistance');
    if (waLabel && !waLabel.getAttribute('data-fayon-wa-bound')) {
      waLabel.setAttribute('data-fayon-wa-bound', '1');
      waLabel.addEventListener('click', function (e) {
        e.preventDefault();
        // ✅ Anchor click — works on ALL pages, ALL browsers, never blocked
        openWhatsApp();
      }, true); // capture phase — fires before Shopify theme can block it
    }
  }

  // ✅ Works whether DOM is ready or still loading
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachHandlers);
  } else {
    attachHandlers();
  }
})();
